module.exports = {"apiKey":"AIzaSyDXRjXvWkjWra4tJBtJBP81qfyeP2HYuI4","authDomain":"smokeless-world-stage.firebaseapp.com","databaseURL":"https://smokeless-world-stage.firebaseio.com","projectId":"smokeless-world-stage","storageBucket":"smokeless-world-stage.appspot.com","messagingSenderId":"710934496394","appId":"1:710934496394:web:1a36d74674b2ce8f245973","measurementId":"G-QTY431LVK8"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase/config.json
// module id = 58
// module chunks = 0